import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Payment } from 'app/shared/models/class/payment/payment';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getPayments(clubCode: string): Observable<Payment[]> {
    return this.http.get<Payment[]>(`${environment.apiUrl}/Payment/${clubCode}`);
  }

}
